import { bankApi } from '@/api/index'
import { IPageInfoRequest, IPageInfoResponse } from '@/domains/CommonDomain'
import { INotiResponse } from '@/domains/NotificationDomain'

const BASE = '/noti'

export interface INotiListResponse {
  baseDtm: number // 서버기준현재시간
  lastNotiReadDtm: number // 최종 알림목록 조회 일시
  list: INotiResponse[] // 리스트
  pageInfo: IPageInfoResponse
}

export const fetchNotification = (data: IPageInfoRequest): Promise<INotiListResponse> => {
  return bankApi.post(`${BASE}/list`, data)
}
